/**
 *  @class
 *  @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const total = parseInt(this.dataset.cartTotal, 10);
      const shippingMinimum = parseInt(this.dataset.minimum, 10);
      const isMulti = this.classList.contains('free-shipping--multi');

      this.remainingText = this.querySelector('.free-shipping--text-remaining');
      this.giftRemainingText = this.querySelector('.free-shipping--text-gift-remaining');
      this.fullText = this.querySelector('.free-shipping--text-full');
      this.allFullText = this.querySelector('.free-shipping--text-all-full');

      if (isMulti) {
        const milestones = this.getMilestones();
        const percentage = this.getMultiSegmentFill(total, milestones);
        this.style.setProperty('--percentage', percentage);
        this.layoutMilestones(milestones);
        milestones.forEach((milestone) => {
          milestone.el.classList.toggle('is-achieved', total >= milestone.min);
        });
        this.updateMultiText(total, milestones);
        return;
      }

      const amountText = this.querySelector('.free-shipping--text span');
      let percentage = 1;
      if (total < shippingMinimum) {
        percentage = total / shippingMinimum;

        if (amountText) {
          const remaining = shippingMinimum - total;
          const format = window.theme.settings.money_with_currency_format || "${{amount}}";
          amountText.innerHTML = formatMoney(remaining, format);
        }
        this.remainingText.style.display = 'block';
        if (this.giftRemainingText) this.giftRemainingText.style.display = 'none';
        this.fullText.style.display = 'none';
        if (this.allFullText) this.allFullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        if (this.giftRemainingText) this.giftRemainingText.style.display = 'none';
        this.fullText.style.display = 'block';
        if (this.allFullText) this.allFullText.style.display = 'none';
      }

      this.style.setProperty('--percentage', percentage);
    }

    getMilestones() {
      return [...this.querySelectorAll('.free-shipping--milestone')]
        .map((el) => ({
          el,
          min: parseInt(el.dataset.min, 10),
          type: el.dataset.type,
          tier: parseInt(el.dataset.tier, 10) || 0
        }))
        .sort((a, b) => a.min - b.min);
    }

    getMultiSegmentFill(total, milestones) {
      const count = milestones.length;
      if (!count) return 0;

      const positions = milestones.map((_, index) => (index + 1) / count);

      if (total <= milestones[0].min) {
        if (milestones[0].min <= 0) return 0;
        return (total / milestones[0].min) * positions[0];
      }

      for (let i = 1; i < count; i += 1) {
        const prevMin = milestones[i - 1].min;
        const currMin = milestones[i].min;
        const prevPos = positions[i - 1];
        const currPos = positions[i];

        if (total <= currMin) {
          if (currMin <= prevMin) return currPos;
          return prevPos + ((total - prevMin) / (currMin - prevMin)) * (currPos - prevPos);
        }
      }

      return 1;
    }

    layoutMilestones(milestones) {
      const count = milestones.length;
      milestones.forEach((milestone, index) => {
        const position = ((index + 1) / count) * 100;
        milestone.el.style.left = `${position}%`;
        milestone.el.classList.toggle('is-first', index === 0);
        milestone.el.classList.toggle('is-middle', index > 0 && index < count - 1);
        milestone.el.classList.toggle('is-last', index === count - 1);
      });
    }

    updateMultiText(total, milestones) {
      const format = window.theme.settings.money_with_currency_format || "${{amount}}";

      if (this.remainingText) this.remainingText.style.display = 'none';
      if (this.giftRemainingText) this.giftRemainingText.style.display = 'none';
      if (this.allFullText) this.allFullText.style.display = 'none';

      const nextMilestone = milestones.find((milestone) => total < milestone.min);
      if (!nextMilestone) {
        if (this.allFullText) this.allFullText.style.display = 'block';
        return;
      }

      const remaining = nextMilestone.min - total;

      if (nextMilestone.type === 'shipping') {
        const amountText = this.remainingText?.querySelector('span');
        if (amountText) {
          amountText.innerHTML = formatMoney(remaining, format);
        }
        if (this.remainingText) this.remainingText.style.display = 'block';
        return;
      }

      const giftAmountText = this.giftRemainingText?.querySelector('span');
      if (giftAmountText) {
        giftAmountText.innerHTML = formatMoney(remaining, format);
      }
      if (this.giftRemainingText) this.giftRemainingText.style.display = 'block';
    }
  }
  customElements.define('free-shipping', FreeShipping);
}
